import { useMemo } from 'react';

import { useAppSelector } from 'shared/lib/redux';

import { selectPledgeEstateDictionaries } from 'entities/pledgeEstateForm';

export const useOptions = () => {
  const dictionaries = useAppSelector(selectPledgeEstateDictionaries);

  return useMemo(
    () => ({
      otherOwnerRelationship: dictionaries.otherOwnerRelationship,
      maritalStatuses: dictionaries.maritalStatuses,
    }),
    [dictionaries.otherOwnerRelationship, dictionaries.maritalStatuses],
  );
};
